module.exports = __webpack_public_path__ + "static/decluttering an attic-2d82f32d05f50a87a146d5f26de61092.png";